import React, { useEffect, useState } from "react";
import { Dialog } from "../Dialog";
import { ErrorBanner, Muted } from "./AppDataStyles";

/**
 * Confirmation before deleting an app data row. Locked rows require an explicit force.
 */
export const DeleteRowDialog = ({
  show = false,
  row = null,
  scope = "global",
  busy = false,
  error = null,
  onClose = () => {},
  onConfirm = () => {},
}) => {
  const [force, setForce] = useState(false);

  useEffect(() => {
    if (show) setForce(false);
  }, [show]);

  return (
    <Dialog
      title="Delete row"
      subtitle={scope === "user" ? "User scope" : "Global scope"}
      show={show}
      onClose={onClose}
      onOK={() => onConfirm(force)}
      okText={busy ? "Deleting…" : "Delete"}
      closeText="Cancel"
      style={{ width: "90%", maxWidth: "560px" }}
    >
      <div style={{ fontSize: "14px", color: "var(--main-font-color)" }}>
        Delete <strong>{row?.name ?? "?"}/{row?.key ?? "?"}</strong>?
      </div>

      <Muted>This permanently removes the row. It cannot be undone.</Muted>

      {row?.locked ? (
        <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: "12.5px", color: "#f39c12" }}>
          <input type="checkbox" checked={force} onChange={(event) => setForce(event.target.checked)} />
          This row is locked — force the delete
        </label>
      ) : null}

      {error ? <ErrorBanner>{error}</ErrorBanner> : null}
    </Dialog>
  );
};

export default DeleteRowDialog;
